import {
  // Components
  Menu,
} from 'floating-vue'
import 'floating-vue/dist/style.css'
export default function (app) {
  app.component('TooltipMenu', Menu)
}
